module.exports = __webpack_public_path__ + "static/media/inf_84og85.a013242d.mp3";